import React from "react";
import PropTypes from "prop-types";

const Redo2Icon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="m15 14 5-5-5-5"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Redo2Icon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Redo2Icon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default Redo2Icon;
